import { findSavedBannerElement, findUnsavedMessageElement } from ".";

export const displayListingUnsavedNotification = ({
  listingId,
  listingType
}) => {
  const unsavedMessage = findUnsavedMessageElement(listingId);
  if (unsavedMessage != null) {
    Object.assign(unsavedMessage.style, { display: "block", opacity: "1" });
    setTimeout(() => {
      Object.assign(unsavedMessage.style, {
        opacity: "0",
        "-moz-transition": "opacity 0.4s ease-in-out",
        "-o-transition": "opacity 0.4s ease-in-out",
        "-webkit-transition": "opacity 0.4s ease-in-out",
        transition: "opacity 0.4s ease-in-out"
      });
      setTimeout(() => {
        Object.assign(unsavedMessage.style, {
          display: "none",
          opacity: "1"
        });
      }, 500);
    }, 4000);
  }

  const savedBanner = findSavedBannerElement(listingType, listingId);
  if (savedBanner != null) {
    savedBanner.classList.add("unsaved");
  }
};
